module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicWide-Bold-608404cb3882325c044aeaea534fc612.woff";